import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import urljoin from 'url-join';
import { useApp } from '../context/AppContext';
import unsafeImageUrl from '../images/lineup-default.png';
import { ContentTag } from './ContentTag';

interface WideImagePropsBase {
  title: string;
  image?: string;
  tags?: string[];
}

type WideImageProps = WideImagePropsBase & React.HTMLAttributes<HTMLDivElement>;

export default function WideImage(props: WideImageProps) {
  const { config } = useApp();
  const defaultImgUrl = urljoin(config.goBaseUrl, unsafeImageUrl);

  const {
    image: imageUrl,
    title,
    tags,
    className: propClasses,
    style: propStyles,
    ...rest
  } = props;
  const [imageError, setImageError] = useState(false);

  const classes = ['relative bg-highlight rounded-lg overflow-hidden'];
  if (propClasses) classes.push(propClasses);
  classes.push('go-wide-image');

  let style: React.CSSProperties = {
    paddingTop: '56.25%',
  };
  if (propStyles) style = { ...style, ...propStyles };

  return (
    <div {...rest} className={classes.join(' ')} style={style}>
      <LazyLoadImage
        className="fullscreen-noscroll"
        wrapperClassName="fullscreen-noscroll"
        loading="lazy"
        src={imageError ? defaultImgUrl : imageUrl || defaultImgUrl}
        onError={() => setImageError(true)}
        alt={title}
      />
      {(tags ?? []).map((tag, i) => (
        <ContentTag key={i} className="absolute bottom-0 right-0 mb-2 mr-2" variant="dark">
          {tag}
        </ContentTag>
      ))}
    </div>
  );
}
